import HeadTitle from '@components/HeadTitle/HeadTitle'

function Index() {
  return (
    <>
      <HeadTitle title={'Havelock'} />
    </>
  )
}

export default Index
